// Progressive-enhancement dropdown: a <details>/<summary> panel of real
// <button> options drives a visually-hidden native <select> so the actual
// form submission is unaffected — only the open-menu presentation changes.
// Native <select> popups can't be restyled cross-browser (Chrome/Safari
// ignore CSS on the open option list beyond background/color, and never
// let you touch the hover highlight), which is what made the plain <select>
// look inconsistent with the rest of the theme.
document.querySelectorAll('[data-custom-select]').forEach((details) => {
  const nativeSelect = details.parentElement.querySelector('[data-custom-select-native]');
  const label = details.querySelector('[data-custom-select-label]');
  const options = Array.from(details.querySelectorAll('.custom-select__option'));

  options.forEach((option) => {
    option.addEventListener('click', () => {
      const value = option.dataset.value;
      nativeSelect.value = value;
      label.textContent = option.textContent.trim();
      options.forEach((other) => other.setAttribute('aria-selected', other === option ? 'true' : 'false'));
      details.open = false;
      details.querySelector('summary').focus();
    });
  });

  details.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && details.open) {
      details.open = false;
      details.querySelector('summary').focus();
    }
  });

  document.addEventListener('click', (event) => {
    if (details.open && !details.contains(event.target)) {
      details.open = false;
    }
  });
});
